import actions from './actions'

export default {
  namespaced: true,
  state: {
    datasets: {}
  },
  mutations: {
    updateDataset: (state, { id, data }) => {
      state.datasets = {
        ...state.datasets,
        [id]: {
          ...state.datasets[id],
          loading: false,
          ...data
        }
      }
    }
  },
  getters: {
    datasets: state => state.datasets
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/metrics/index.js